<template>
  <div class="container">
    <div v-if="!commercialType" class="row d-flex flex-column-reverse flex-lg-row">
      <div class="col-lg-12">
        <div class="row">
          <div
            class="col-md-4"
            v-for="commercialTypeOption in commercialTypeOptions"
            :key="commercialTypeOption.slug"

          >
            <v-register-commercial-option
              :slug="commercialTypeOption.slug"
              :image-path="commercialTypeOption.imagePath"
              :is-public="!user.isAuthenticated"
            />
          </div>
        </div>

        <v-partner-carousel
          :per-page="8"
        />
      </div>
    </div>

    <div class="mb-3">
      <v-register-commercial-tv
        @research-type-selected="(researchType) => {goToResearchWizard(researchType, 'tv')}"
        v-if="commercialType === 'tv'"
      />
      <v-register-commercial-radio
        @research-type-selected="(researchType) => {goToResearchWizard(researchType, 'radio')}"
        v-if="commercialType === 'radio'"
      />
      <v-register-commercial-ooh
        @research-type-selected="(researchType) => {goToResearchWizard(researchType, 'ooh')}"
        v-if="commercialType === 'ooh'"
      />
    </div>

    <v-auth-modal
      v-if="selectedResearchType !== null"
      sub-title="sentence.login_to_register_commercial"
      :title="`word.${selectedResearchType}`"
      :closable="true"
      :as-organisation="true"
      @authenticated="goToWizard"
      @hide-modal="selectedResearchType = null"
    />
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { notify, pageNotFound } from '@/common/utils/notify';
import AuthModal from '@/common/components/auth/AuthModal.vue';
import RegisterCommercialStartRadio from '@/common/components/register-commercial/StartRadio.vue';
import RegisterCommercialStartOOH from '@/common/components/register-commercial/StartOOH.vue';
import RegisterCommercialStartTv from '@/common/components/register-commercial/StartTv.vue';
import RegisterCommercialOption from '@/common/components/register-commercial/Option.vue';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import PartnerCarousel from '@/common/components/carousels/PartnerCarousel.vue';


const AVAILABLE_COMMERCIAL_TYPES = [
  'tv',
  'radio',
  'ooh',
  'other',
];

export default {
  name: 'RegisterResearchStart',
  components: {
    'v-auth-modal': AuthModal,
    'v-register-commercial-tv': RegisterCommercialStartTv,
    'v-register-commercial-radio': RegisterCommercialStartRadio,
    'v-register-commercial-ooh': RegisterCommercialStartOOH,
    'v-register-commercial-option': RegisterCommercialOption,
    'v-partner-carousel': PartnerCarousel,
  },
  computed: {
    ...mapGetters(['user', 'org']),
  },
  data() {
    return {
      showText: false,
      selectedResearchType: null,
      commercialType: null,
      commercialTypeOptions: [
        {
          slug: 'tv',
          // eslint-disable-next-line global-require
          imagePath: `url('${require('@/common/assets/img/television.png')}')`,
        },
        {
          slug: 'radio',
          name: this.$t('word.radio_commercial'),
          // eslint-disable-next-line global-require
          imagePath: `url('${require('@/common/assets/img/radio.png')}')`,
        },
        {
          slug: 'ooh',
          // eslint-disable-next-line global-require
          imagePath: `url('${require('@/common/assets/img/billboard.png')}')`,
        },
        {
          slug: 'dooh',
          // eslint-disable-next-line global-require
          imagePath: `url('${require('@/common/assets/img/digital-signage.png')}')`,
        },
        {
          slug: 'other',
          // eslint-disable-next-line global-require
          imagePath: `url('${require('@/common/assets/img/research.png')}')`,
        },
      ],
    };
  },
  methods: {
    goToResearchWizard(researchType, commercialType) {
      if (!this.user.isAuthenticated) {
        this.selectedResearchType = researchType;
        return;
      }
      if (researchType === 'test') {
        this.$router.push({ name: 'organisation-request-research' });
      } else {
        this.$router.push({
          name: 'organisation-create-research',
          params: { researchType: `${researchType}-${commercialType}` },
        });
      }
    },
    goToWizard() {
      notify('phrase.logged_in', 'sentence.register_commercial');
      this.goToResearchWizard(this.selectedResearchType, this.commercialType);
    },
  },
  created() {
    if (this.$route.query.commercialType) {
      this.commercialType = this.$route.query.commercialType;
    }

    if (this.commercialType && !AVAILABLE_COMMERCIAL_TYPES.includes(this.commercialType)) {
      pageNotFound();
      if (this.user.isAuthenticated) {
        // Temporarily: in the future, everything should go through the research wizard;
        this.$router.push({ name: 'organisation-dashboard' });
      } else {
        this.$router.push({ name: 'home' });
      }
      return;
    }

    if (this.$route.query.researchType) {
      this.selectedResearchType = this.$route.query.researchType;
      this.goToResearchWizard(this.selectedResearchType, this.commercialType);
    }

    if (this.user.isAuthenticated) {
      if (this.commercialType) {
        setBreadcrumbs('organisation.registerCommercial', [this.commercialType]);
      } else {
        setBreadcrumbs('organisation.registerCommercial');
      }
    }
  },
  mounted() {
    setTimeout(() => { this.showText = true; }, 1);
  },
};
</script>
